export default "__VITE_ASSET__CJXJqJYU__"